import React, { useState, useEffect } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import axios from "axios";
import mmddyy from "../../../utils/mmddyy";

const ContactUs = () => {
  const [contacts, setContacts] = useState(null);

  const retrieveContactUs = async () => {
    try {
      await axios.get("/api/contactUs").then((response) => {
        setContacts(response.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    retrieveContactUs();
  }, []);
  return (
    <Table>
      <TableHead>
        <TableRow sx={{ background: "#2e66b0" }}>
          <TableCell sx={{ color: "white" }}>Name</TableCell>
          <TableCell sx={{ color: "white", textAlign: "center" }}>
            Company
          </TableCell>
          <TableCell sx={{ color: "white", textAlign: "center" }}>
            Phone
          </TableCell>
          <TableCell sx={{ color: "white", textAlign: "center" }}>
            Email
          </TableCell>
          <TableCell sx={{ color: "white", textAlign: "center" }}>
            Submission Date
          </TableCell>
          <TableCell sx={{ color: "white", textAlign: "center" }}>
            Message
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {contacts !== null &&
          contacts.map((contact) => (
            <TableRow key={contact.contact} hover>
              <TableCell>{contact.contact}</TableCell>
              <TableCell sx={{ textAlign: "center" }}>
                {contact.company}
              </TableCell>
              <TableCell sx={{ textAlign: "center" }}>
                {contact.phone}
              </TableCell>
              <TableCell sx={{ textAlign: "center" }}>
                {contact.email}
              </TableCell>
              <TableCell sx={{ textAlign: "center" }}>
                {mmddyy(contact.register_date)}
              </TableCell>
              <TableCell sx={{ textAlign: "center" }}>
                {contact.message}
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};

export default ContactUs;
